import FaqLikeDislikeButton from './components/pages/frontoffice/faq_categories/faqLikeDislikeButton';
customElements.define('faq-like-dislike-button', FaqLikeDislikeButton,{extends: 'a'});

import FaqSearch from './components/pages/frontoffice/faq_categories/faqSearch';
customElements.define('faq-search', FaqSearch,{extends: 'input'});

import FaqQuestionToOpen from './components/pages/frontoffice/faq_categories/faqQuestionToOpen';
customElements.define('faq-question-to-open', FaqQuestionToOpen,{extends: 'div'});